<template>
  <div id="app">
    <router-view></router-view>
    <x-notification />
  </div>
</template>

<script>
import { constantRoutes } from "@/router";
import XNotification from "@/components/XNotification";
import { resetRouter } from "@/router/index";
import { jsonp } from "vue-jsonp";
import store from "@/store";
import { _getPermissionMenuTreeAllData } from "@/utils/changeRouter";
export default {
  name: "App",
  components: { XNotification },
  data() {
    return {
      systemPageData: [],
    };
  },
  created() {
    //根据token判断是否登录,进行路由更新
    if (this.$store.state.user.token) {
      _getPermissionMenuTreeAllData();
    }
     // 全局前置路由
     this.$router.beforeEach(async (to, from, next) => {
      // 获取缓存标签
      const cacheTags = store.state.tagsView.cachedViews;
      // console.log("----------------------", store.state.tagsView.cachedViews);
      // 看跳转到路由信息 是否之前已经缓存过
      const findRes = cacheTags.find((item) => item === to.name);

      // 匹配是否为详情页
      if (/(detail)|(Detail)/.test(to.name)) {
        console.log("isDetail");
        to.meta.keepAlive = false;
        next();
        return;
      }

      console.log("ifInCacheViews", to.query.ifInCacheViews);
      // 如果是从tagViews中跳转到的 就进行缓存
      if (to.query.ifInCacheViews) {
        to.meta.keepAlive = true;
        next();
        return;
      }
      // console.log("findRes", !!JSON.parse(JSON.stringify(findRes)));
      // 如果之前是缓存的 就取消缓存重新获取
      if (findRes) {
        to.meta.keepAlive = false;
        await store.dispatch("tagsView/delView", to); // 在vuex清掉对应的view
        next();
        return;
      }
      next();
    });
  },
  methods: {
  },
};
</script>

<style lang="scss">

</style>
